/* Folk Revival product page extras, added 2026-10-09 (v4: one tap to a full-screen video with sound).
   1. The nutrition facts links inside the Ingredients accordion open in an on-page
      lightbox instead of a new tab, so the visitor stays on the product page. The
      images are fetched early (when the accordion opens, or on touch of a link) and
      the panel shows at once with a "Loading" note, so there is no visible lag.
   2. One tap on the video slide plays the product video full screen with the sound
      on, and leaving full screen returns the visitor to the product page.
   Both are additive: with scripts off the links still open the image and the video
   still plays inline. */
(function () {
  'use strict';

  var IOS = /iPhone|iPad|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  /* ---------- 1. nutrition lightbox ---------- */
  var IMG_RE = /\.(jpe?g|png|webp)(\?.*)?$/i;
  var LINKS = '.product_accordian_faq a[href], .metafield-rich_text_field a[href]';
  var box = null, img = null, panel = null, closeBtn = null, lastFocus = null;
  var preloaded = {};

  function preload(href) {
    if (!href || preloaded[href]) return;
    preloaded[href] = true;
    var i = new Image();
    i.decoding = 'async';
    i.src = href;
  }

  function imageLink(el) {
    if (!el || !el.closest) return null;
    var a = el.closest(LINKS);
    if (!a) return null;
    return IMG_RE.test(a.getAttribute('href') || '') ? a : null;
  }

  function build() {
    box = document.createElement('div');
    box.className = 'fr-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Nutrition facts');
    box.innerHTML =
      '<button type="button" class="fr-lightbox__close" aria-label="Close">&times;</button>' +
      '<div class="fr-lightbox__panel"><img class="fr-lightbox__img" alt="Nutrition facts and ingredients" decoding="async"></div>' +
      '<p class="fr-lightbox__hint">Tap the image to zoom. Tap outside it to close.</p>';
    document.body.appendChild(box);
    img = box.querySelector('.fr-lightbox__img');
    panel = box.querySelector('.fr-lightbox__panel');
    closeBtn = box.querySelector('.fr-lightbox__close');
    img.addEventListener('load', function () { box.classList.remove('is-loading'); });
    img.addEventListener('error', function () { box.classList.remove('is-loading'); });
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target === closeBtn) close();
    });
    img.addEventListener('click', function () { box.classList.toggle('is-zoomed'); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) close();
    });
  }

  function open(href, alt) {
    if (!box) build();
    box.classList.remove('is-zoomed');
    box.classList.add('is-loading');
    if (alt) img.alt = alt;
    panel.scrollTop = 0;
    box.classList.add('is-open');
    document.documentElement.classList.add('fr-lightbox-open');
    lastFocus = document.activeElement;
    closeBtn.focus();
    if (img.getAttribute('src') === href && img.complete && img.naturalWidth > 0) {
      box.classList.remove('is-loading');
    } else {
      img.src = href;
      if (img.complete && img.naturalWidth > 0) box.classList.remove('is-loading');
    }
  }

  function close() {
    box.classList.remove('is-open');
    document.documentElement.classList.remove('fr-lightbox-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* fetch the images as soon as the Ingredients accordion opens, and on first touch of a link */
  document.addEventListener('click', function (e) {
    var title = e.target && e.target.closest && e.target.closest('.acc__title');
    if (!title) return;
    var card = title.closest('.acc__card') || title.parentElement;
    if (!card) return;
    Array.prototype.forEach.call(card.querySelectorAll(LINKS), function (a) {
      var href = a.getAttribute('href') || '';
      if (IMG_RE.test(href)) preload(href);
    });
  }, true);
  ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var a = imageLink(e.target);
      if (a) preload(a.getAttribute('href'));
    }, true);
  });

  document.addEventListener('click', function (e) {
    var a = imageLink(e.target);
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    open(a.getAttribute('href'), (a.textContent || '').replace(/[^\w\s&,'-]/g, '').replace(/\s+/g, ' ').trim());
  });

  /* ---------- 2. the product video: one tap, full screen, sound on ---------- */
  /* How the theme is wired: the video slide in the carousel is a lightbox opener. A
     tap opens the theme's photo lightbox, which holds the real video behind a poster
     button; that video starts muted and inline. Four taps to a full-screen video with
     sound. This makes it one: the same tap opens the lightbox, presses its poster
     button, turns the sound on and goes full screen. When the visitor leaves full
     screen, the video pauses and the lightbox closes, back on the product page. */

  function fixTemplates() {
    Array.prototype.forEach.call(document.querySelectorAll('deferred-media template'), function (t) {
      var v = t.content && t.content.querySelector ? t.content.querySelector('video') : null;
      if (!v) return;
      v.removeAttribute('muted');                 /* the tap is the visitor's choice, so sound on */
      v.setAttribute('preload', 'metadata');
      if (IOS) {                                   /* Safari plays full screen in its own player without this flag */
        v.removeAttribute('playsinline');
        v.removeAttribute('webkit-playsinline');
      }
    });
  }
  fixTemplates();
  document.addEventListener('DOMContentLoaded', fixTemplates);

  function enterFullscreen(v) {
    try {
      if (IOS && v.webkitEnterFullscreen) {
        if (!v.webkitDisplayingFullscreen) v.webkitEnterFullscreen();
        return;
      }
      if (v.requestFullscreen) {
        var p = v.requestFullscreen();
        if (p && p.catch) p.catch(function () {});
      } else if (v.webkitRequestFullscreen) {
        v.webkitRequestFullscreen();
      }
    } catch (err) { /* not ready or not permitted; the video still plays */ }
  }

  function leaveHandlers(v, modal) {
    if (v.dataset.frLeave) return;
    v.dataset.frLeave = '1';
    var back = function () {
      try { v.pause(); } catch (err) {}
      if (modal && modal.hide && modal.hasAttribute('open')) modal.hide();
    };
    v.addEventListener('webkitendfullscreen', back);
    document.addEventListener('fullscreenchange', function () {
      if (!document.fullscreenElement) back();
    });
  }

  function startVideo(dm, modal) {
    var poster = dm.querySelector('.deferred-media__poster');
    if (!dm.getAttribute('loaded') && poster) poster.click();   /* the theme inserts the video and calls play() */
    var v = dm.querySelector('video');
    if (!v) return;
    try { v.muted = false; } catch (err) {}
    enterFullscreen(v);
    if (IOS) {
      v.addEventListener('loadedmetadata', function () { enterFullscreen(v); }, { once: true });
      v.addEventListener('playing', function () { enterFullscreen(v); }, { once: true });
    }
    leaveHandlers(v, modal);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    /* the video slide in the carousel: the theme has just opened its lightbox */
    var opener = e.target.closest('.product__modal-opener--video');
    if (opener) {
      var modal = document.querySelector(opener.getAttribute('data-modal') || '');
      var btn = opener.querySelector('button');
      var id = btn ? btn.getAttribute('data-media-id') : null;
      var dm = modal && id ? modal.querySelector('deferred-media[data-media-id="' + id + '"]') : null;
      if (dm) { startVideo(dm, modal); return; }
    }
    /* a poster button pressed directly, in the lightbox or anywhere else */
    var dmDirect = e.target.closest('deferred-media');
    if (dmDirect && e.target.closest('.deferred-media__poster')) {
      var v = dmDirect.querySelector('video');
      if (v) {
        try { v.muted = false; } catch (err) {}
        enterFullscreen(v);
        leaveHandlers(v, dmDirect.closest('product-modal'));
      }
    }
  });
})();
